import Fetcher from "@netless/fetch-middleware";
import { miniPersistStore } from "src/models/MiniPersistStore";

if (!process.env.CONSOLE_LAMBDA_ORIGIN) {
    throw new Error("need set process.env.CONSOLE_LAMBDA_ORIGIN");
}
const fetcher = new Fetcher(10000, process.env.CONSOLE_LAMBDA_ORIGIN);
export class FinanceOperator {

    public async getInvoiceInf(): Promise<any> {
        const json = await fetcher.get<any>({
            path: `invoice`,
            headers: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async updateInvoiceInf( bankName: string,
                                   bankNumber: string,
                                   code: string,
                                   invoiceType: number,
                                   issuingType: number,
                                   registerAddress: string,
                                   registerPhone: string,
                                   title: string): Promise<any> {
        const json = await fetcher.patch<any>({
            path: `invoice`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                bankName: bankName,
                bankNumber: bankNumber,
                code: code,
                invoiceType: invoiceType,
                issuingType: issuingType,
                registerAddress: registerAddress,
                registerPhone: registerPhone,
                title: title,
            },
        });
        return json as any;
    }

    public async getAddressInf(): Promise<any> {
        const json = await fetcher.get<any>({
            path: `mail-address`,
            headers: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async updateAddressInf(name: string, address: string, phone: string, postCode: string): Promise<any> {
        const json = await fetcher.patch<any>({
            path: `mail-address`,
            headers: {
                token: miniPersistStore.token,
            },
            body: {
                name: name,
                address: address,
                phone: phone,
                postCode: postCode,
            },
        });
        return json as any;
    }
}


// WEBPACK FOOTER //
// ./src/apiMiddleware/FinanceOperator.ts